<kendo-tilelayout autoFlow="row-dense" [columns]="3">
  <kendo-tilelayout-item *ngFor="let tile of userTiles" [order]="tile.order">
    <kendo-tilelayout-item-header>

      <span kendoTooltip class="t-tooltip static" [tooltipWidth]="350" title="{{tile.info}}" style="z-index:105"
        tooltipClass="t-tooltip-info" filter=".t-tooltip">
        <i class="fas fa-info-circle t-icon t-icon-info"></i>
      </span>

      <span *ngIf="tile.hasHeaderExport" title="Export to Excel"
        class="float-right mt-2 far fa-file-excel t-icon t-icon-primary col-span-1"
        (click)="onExportClick(tile.type)"></span>
      <h5 class="k-card-title">{{tile.title}}</h5>
    </kendo-tilelayout-item-header>

    <div class="col mt-2">
      <!-- Credit Approvals and POAcks -->
      <div *ngIf="tile.type === TileType.CreditApprovalBacklog">
        <tsmt-credit-backlog-dashboard></tsmt-credit-backlog-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.MyCreditApprovalAndPOAcks">
        <tsmt-credit-and-poack-dashboard [showMyRequests]="onlyShowMyRequests">
        </tsmt-credit-and-poack-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.CreditMetrics">
        <tsmt-credit-metrics-dashboard></tsmt-credit-metrics-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.YOYCreditMetrics">
        <tsmt-yoy-credit-metrics-dashboard></tsmt-yoy-credit-metrics-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.CreditLinks">
        <tsmt-credit-quick-links-dashboard></tsmt-credit-quick-links-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.ReturnReasonCounts">
        <tsmt-return-reasons-counts [export]="exportReturnReasons"></tsmt-return-reasons-counts>
      </div>
      <!-- Credit Approvals and POAcks / end -->
      <!-- Work Packages -->
      <div *ngIf="tile.type === TileType.WorkPackageValidationRequests">
        <tsmt-workpackage-dashboard-validation-requests [showMyRequests]="onlyShowMyRequests">
        </tsmt-workpackage-dashboard-validation-requests>
      </div>

      <div *ngIf="tile.type === TileType.WorkPackageApprovalRequests">
        <tsmt-workpackage-dashboard-approval-requests></tsmt-workpackage-dashboard-approval-requests>
      </div>
      <div *ngIf="tile.type === TileType.WorkPackageTransitionRequests">
        <tsmt-workpackage-dashboard-transition-requests [showMyRequests]="onlyShowMyRequests">
        </tsmt-workpackage-dashboard-transition-requests>
      </div>

      <div *ngIf="tile.type === TileType.WorkPackageTransmitRequests">
        <tsmt-workpackage-dashboard-transmit-requests></tsmt-workpackage-dashboard-transmit-requests>
      </div>
      <!-- Work Packages / end -->
      <!-- PA / PM -->
      <div *ngIf="tile.type === TileType.FinalFinisherGaps">
        <tsmt-final-finisher-gaps-dashboard [drAddressId]="drAddressId" [showMyRequests]="onlyShowMyRequests">
        </tsmt-final-finisher-gaps-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.PlannedShipmentCommitted">
        <tsmt-planned-shipment-committed-dashboard [drAddressId]="drAddressId" [showMyRequests]="onlyShowMyRequests">
        </tsmt-planned-shipment-committed-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.SpaExpiringPlannedShipmentCommitted">
        <tsmt-spa-expiring-shipments-dashboard [drAddressId]="drAddressId" [showMyRequests]="onlyShowMyRequests">
        </tsmt-spa-expiring-shipments-dashboard>
      </div>

      <div *ngIf="tile.type === TileType.PlannedShipmentUpcomingReleased">
        <tsmt-planned-shipment-released-dashboard [drAddressId]="drAddressId" [showMyRequests]="onlyShowMyRequests">
        </tsmt-planned-shipment-released-dashboard>
      </div>
      <div *ngIf="tile.type === TileType.RevenueOutOfBalance">
        <tsmt-revenue-out-of-balance-dashboard [drAddressId]="drAddressId" [showMyRequests]="onlyShowMyRequests">
        </tsmt-revenue-out-of-balance-dashboard>
      </div>
      <div *ngIf="tile.type === TileType.AccountsPayableThreeWayMatch">
        <tsmt-accounts-payable-three-way-match [drAddressId]="drAddressId" [showMyRequests]="onlyShowMyRequests">
        </tsmt-accounts-payable-three-way-match>
      </div>
      <!-- PA/PM / end-->
    </div>
  </kendo-tilelayout-item>
</kendo-tilelayout>
